export const normalizeCertificates = value =>
	(Array.isArray(value) ? value : [])
		.map(item => ({
			certificateId: `${item?.certificateId ?? item?.certificationId ?? item?._id ?? ''}`.trim(),
			certificateName: `${item?.certificateName ?? item?.name ?? item?.nazwa ?? ''}`.trim(),
		}))
		.filter(item => item.certificateId)
